// extracted by mini-css-extract-plugin
module.exports = {"container":"post_card_container__hqdv9","content":"post_card_content__Cjhm8","header":"post_card_header__PE405"};